import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { BookOpen, TrendingUp, ShieldCheck } from 'lucide-react';
export function Hero() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  return <section className="bg-brand-white pt-24 pb-16 md:pt-32 md:pb-24 px-6 overflow-hidden" data-id="element-149">
      <div className="max-w-6xl mx-auto" data-id="element-150">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-151">
          <div className="flex-1 text-center lg:text-left" data-id="element-152">
            <FadeIn data-id="element-153">
              <div className="inline-block bg-brand-green text-white font-bold px-8 py-3.5 rounded-full text-lg md:text-xl mb-6 border border-brand-gold/40 tracking-widest uppercase shadow-xl" data-id="element-154">
                INGRESOS ONLINE DESDE CASA
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-155">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-green leading-tight mb-6" data-id="element-156">
                APRENDE CÓMO GENERAR INGRESOS DESDE CASA USANDO AMAZON, INCLUSO
                SI EMPIEZAS DESDE CERO
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-157">
              <p className="text-sm font-semibold text-brand-gold uppercase tracking-wider mb-4" data-id="element-158">
                PASO A PASO | SIN EXPERIENCIA | ACCESO INMEDIATO | AMAZON SELLER
              </p>
              <p className="text-lg md:text-xl text-brand-text mb-4 leading-relaxed" data-id="element-159">
                Aprende paso a paso cómo utilizar la plataforma de ventas Amazon
                Seller desde cero: cómo publicar productos, crear campañas,
                gestionar pedidos y comenzar correctamente aunque no tengas
                experiencia previa.
              </p>
              <p className="text-lg md:text-xl text-brand-text mb-8 leading-relaxed" data-id="element-160">
                Descubre cómo funciona realmente Amazon para vender con más
                estructura, menos errores y mayor claridad desde casa. Además,
                con los bonos incluidos conocerás productos con potencial y cómo
                identificarlos estratégicamente.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-161">
              <div className="bg-brand-beige/50 p-6 rounded-xl mb-10 border border-brand-gold/20" data-id="element-162">
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-brand-text font-medium" data-id="element-163">
                  <span data-id="element-164">✔ Acceso inmediato</span>
                  <span data-id="element-165">✔ Método claro y fácil de seguir</span>
                  <span data-id="element-166">✔ Ideal para principiantes</span>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-167">
              <Button onClick={goToCheckout} className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-168">
                QUIERO EMPEZAR A GENERAR INGRESOS HOY
              </Button>
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none" data-id="element-169">
            <FadeIn delay={0.3} data-id="element-170">
              <img src="https://cdn.magicpatterns.com/uploads/91JGFMLPCxeBmQ6GN9u4tX/portada_como_vender_en_amazon_comprimida_.png" alt="Cómo Vender en Amazon FBA Desde Cero (2026) - Guía Completa" className="w-full h-auto rounded-2xl shadow-2xl object-contain" data-id="element-171" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}